import { Product } from "../types/saleOrder";
import { CartProduct } from "../types/cart";

export function productToCartProduct(product: Product): CartProduct {
  const id = String(product.id);
  const name = String(product.name ?? product.title ?? product.code ?? id);
  return {
    id,
    name,
    title: String(product.title ?? name),
    code: String(product.code ?? id),
    stock: Number(product.stock ?? 0),
    batch: product.batch ? String(product.batch) : undefined,
    expiryDate: product.expiryDate ? String(product.expiryDate) : undefined,
    price: Number(product.price ?? 0),
    category: String(product.category ?? "General"),
    maxQtyPerCustomer:
      Number(product.maxQtyPerCustomer) > 0
        ? Number(product.maxQtyPerCustomer)
        : undefined,
    description: product.description,
  };
}
